module.exports = __webpack_public_path__ + "static/media/site.2fc8b646.svg";